import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const ROUNDDOWN = () => {
  return (
    <CardSection id="ROUNDDOWN" title="ROUNDDOWN">
      <Paragraph>지정한 소수 자릿수까지 숫자를 내림합니다.</Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>ROUNDDOWN(VALUE, PLACES)</Paragraph>
        <Ul>
          <Li>
            <b>VALUE</b>는 내림하려는 실수입니다.
          </Li>
          <Li>
            <b>PLACES</b>는 몇 번째 소수점 자리에서 내릴지 지정하는 숫자입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>ROUNDDOWN(`Column`, 2)</Paragraph>
        <Img src="computeRoundDown" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          <b>ROUNDDOWN</b>은 <b>ROUND</b>와 비슷하지만 항상 소수점 아래를
          내림합니다.
        </Paragraph>
        <Paragraph>
          제공하는 <b>VALUE</b>는 실수이거나, 실수를 포함하는 열이거나, 실수를
          반환하는 함수여야 합니다.
        </Paragraph>
        <Paragraph>
          <b>PLACES</b> 값은 양의 정수여야 합니다 (음수이거나 소수점이
          포함되어서는 안 됩니다). 지정한 것보다 소수점 자릿수가 적은{" "}
          <b>VALUE</b>는 <b>ROUNDDOWN</b> 함수의 영향을 받지 않습니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
